import { Component, inject, OnDestroy, OnInit, signal, TemplateRef } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { companyNoValidator } from '../../shared/utils/validator.util';
import { TranslateService } from '@ngx-translate/core';
// import { CompanyCodeMappingService } from '../../shared/services/company-code-mapping.service';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ID_LOGIN_TYPE } from '../../shared/constants/common.constants';
import { AuthService } from '../../shared/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { VerifyEnterpriseService } from '../../shared/services/verify-enterprise.service';
import { MemberInfoResponse, ModifyInfoService } from '../../shared/services/modify-info.service';
import { STORAGE_KEY } from '../../shared/constants/store-key.constants';
import { CtaDialogComponent } from '../../shared/components/dialogs/cta-dialog/cta-dialog.component'
import { LANGS } from '../../shared/constants/lang.constants';
import { HomeRouterDialogComponent } from '../../shared/components/dialogs/home-router-dialog/home-router-dialog';
import { Subscription } from 'rxjs';
interface BuddyIcon {
  id: string;
  title: string;
  subtitle: string;
}
@Component({
  selector: 'app-index',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTabsModule, NgOptimizedImage, MatCardModule, ScrollingModule, ReactiveFormsModule],
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})
export class IndexComponent implements OnInit, OnDestroy, AfterViewInit {
  translateService: TranslateService = inject(TranslateService);
  // companyCodeMappingService: CompanyCodeMappingService = inject(CompanyCodeMappingService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);
  route: ActivatedRoute = inject(ActivatedRoute);
  dialog: MatDialog = inject(MatDialog);
  verifyEnterpriseService: VerifyEnterpriseService = inject(VerifyEnterpriseService);
  // 建立一個訊號來標記是否已進入視窗
  isSectionInView = signal(false);
  private readonly buddyInterval = 2000;//buddy切換間隔
  private buddyIndex = 0;
  @ViewChild('sectionTeam') sectionTeam!: ElementRef;
  @ViewChild('mythCards') mythCards!: ElementRef<HTMLDivElement>;
  @ViewChild('buddyGrid') buddyGrid!: ElementRef<HTMLDivElement>;
  @ViewChild('enTemplate') enTemplate!: TemplateRef<any>;
  showAnimation: boolean =
    this.sharedStorageService.get('homeShowAnimation') ?? true; // 是否展示landing page
  showTitleBlockAnimation: boolean =
    this.sharedStorageService.get('homeShowAnimation') ?? true; // 是否展示title block動畫
  showPageContent: boolean = true;
  currentMythIndex = 0;
  enterpriseCode = signal('');
  activeBuddyTab = signal(0);
  flippedCards = signal<Set<number>>(new Set());
  hoveredBuddy = signal(0);
  displayStartIndex = signal(0);
  private carouselTimer?: any;
  // 宣告手機版目前顯示的索引
  mobileBuddyIndex = signal(0);
  isDragging = false;
  startX = 0;
  scrollLeftStart = 0;
  private buddyTimer?: ReturnType<typeof setInterval>;
  private autoScrollTimer?: ReturnType<typeof setInterval>;
  protected readonly LANGS = LANGS;
  isButtonDisabled = false;//預防多次點擊
  isFormSubmitted = false;
  currentLang = this.translateService.currentLang;
  flowCode: string = this.sharedStorageService.get('myReservation')?.flowCode ?? '';
  enterpriseCodeControl = new FormControl('', [
    Validators.required,
    (control: FormControl) => companyNoValidator(control, this.translateService)
  ]);
  // 建立對應 assets/img 的圖示陣列
  buddyIcons: BuddyIcon[] = [
    { id: 'type-logistics', title: '高度勞動的工作者', subtitle: '每日奔波勞動，很少停下來問問自己還好嗎' },
    { id: 'type-sweet', title: '愛吃甜食的美食家', subtitle: '吃喜歡的東西，至少先知道影響有多大' },
    { id: 'type-housewife', title: '守護家庭的照顧者', subtitle: '想持續照顧家人，得先顧好自己' },
    { id: 'type-oldman', title: '繼續體驗人生的退休人士', subtitle: '知道身體的現況比什麼都踏實' },
    { id: 'type-meal', title: '生活習慣很自律的人', subtitle: '想知道維持的方向夠不夠' },
    { id: 'type-student', title: '從來沒做過健檢的人', subtitle: '正好現在開始認識自己的健康狀況' },
    { id: 'type-athlete', title: '經常熬夜的追劇仔', subtitle: '為了喜歡的事熬夜，更想知道身體需要什麼' },
    { id: 'type-office', title: '整天坐在電腦前的上班族', subtitle: '更需要知道身體悄悄累積了什麼' },
    { id: 'type-gym', title: '規律健身的練家子', subtitle: '更清楚知道自己的健康成績單' }
  ];
  readonly buddyCount = this.buddyIcons.length;
  // 更新後的 Tabs 資料
  buddyTabs = [
    { label: '知道自己底細的人', icon: '🧬' },
    { label: '孩子長大後的媽媽', icon: '👩‍👧‍👦' },
    { label: '生活步調緊湊的人', icon: '🏃' },
    { label: '有過敏體質的人', icon: '🤧' },
    { label: '尋找屬於自己的樣貌', icon: '✨' },
  ];

  buddyCards = [
    {
      reason: ['家人有糖尿病'],
      recommended: ['HbA1c', '代謝基因', '飯前胰島素(含阻抗)'],
      note: '依據衛生福利部資料，有糖尿病家族史者，罹患糖尿病的機率較一般人高出 2 倍以上。具相似背景的受檢者。',
      image: 'assets/img/buddy-detective.svg'
    },
    {
      reason: ['女性', '年齡 > 50 歲'],
      recommended: ['骨質密度', '維生素 D3', '乳房X光攝影'],
      note: '停經後骨質流失速率為之前的 3～5 倍，維生素 D3 缺乏於此年齡層亦屬常見。隨年齡增長乳腺組織趨於退化，乳房攝影能偵測微小鈣化點。',
      image: 'assets/img/buddy-mother.svg'
    },
    {
      reason: ['胃食道逆流', '火燒心', '生活壓力大'],
      recommended: ['胃鏡', '糞便幽門桿菌', '自律神經檢測'],
      note: '胃鏡用於觀察食道與胃部黏膜影像，幽門桿菌檢測用於了解胃部菌叢環境，自律神經檢測心率變異數值，量化神經壓力是否失衡。',
      image: 'assets/img/buddy-woker.svg'
    },
    {
      reason: ['過敏'],
      recommended: ['24 項過敏原檢測', '全免疫球蛋白 E 定量'],
      note: '透過血液檢測 24 種常見過敏原，涵蓋黴菌、動物皮毛、家塵螨及蝦、蛋、牛奶等食物類別，產出各項免疫反應數值。',
      image: 'assets/img/buddy-sensitive.svg'
    },
    {
      reason: ['過敏'],
      recommended: ['24 項過敏原檢測', '全免疫球蛋白 E 定量'],
      note: '透過血液檢測 24 種常見過敏原，涵蓋黴菌、動物皮毛、家塵螨及蝦、蛋、牛奶等食物類別，產出各項免疫反應數值。',
      image: 'assets/img/buddy-sensitive.svg'
    },

  ];
  doctorInfo = {
    image: 'assets/img/doctor-chen.svg',
    name: '陳醫師',
    title: '預防醫學首席顧問'
  };
  myths = [
    {
      num: '01',
      question: '我還年輕、身體很好，\n需要健檢嗎？',
      answer: '三高早已不是中老年專利。根據國健署統計，30 至 39 歲族群中，高血脂盛行率 18.7%、高血壓 9.7%、高血糖 2.5%，顯示相關數值在年輕族群中亦有一定分布。三高相關慢性病佔據十大死因一半，年輕族群的健康數據與中老年的差距正在縮小。',
    },
    {
      num: '02',
      question: '每年都有去健檢，\n是不是就足夠了解健康狀況了？',
      answer: '不一定。標準方案的設計以普遍性為優先，涵蓋的檢查範圍對所有人相同。但每個人的年齡、家族史、生活習慣不同，關注的健康面向也不一樣。「年年健檢、年年正常」不代表所有面向都已涵蓋，只代表標準方案內的項目在正常範圍內。',
    },
    {
      num: '03',
      question: '沒感覺就代表沒問題',
      answer: '許多生理數值的變化在早期不會產生明顯感受。高血壓被稱為「無聲殺手」，根據衛福部資料，全台逾 529 萬人受影響，其中許多人在確認前並無自覺症狀。部分數值的變化只能透過檢查儀器呈現，感覺正常不等於數值正常。 ',
    },
    {
      num: '04',
      question: '家裡沒有遺傳病史，\n是不是就不用擔心？',
      answer: '家族病史是風險因子之一，以糖尿病為例，根據國健署資料，除遺傳因素外，吸菸、飲酒過量、缺乏運動等生活習慣，以及高血壓、高血脂等健康狀況，同樣是不可忽視的危險因子。這些因子的狀態，部分可透過檢查數值呈現。',
    },

  ];

  teamRoles = [
    { role: '醫師', desc: '制定檢查推薦邏輯' },
    { role: '護理師', desc: '守護檢查項目細節' },
    { role: '營養師', desc: '從生活習慣找出風險' },
    { role: '健康管理師', desc: '整合健康分析資訊' },
  ];

  locations = [
    { name: '敦御、敦平、富霖診所', address: '台北敦南中心', address1: '台北市大安區敦化南路二段333號 3-5 樓', address2: '' },
    { name: '瑞成、瑞健、瑞宏診所', address: '台北內湖中心', address1: '台北市內湖區瑞光路 258巷', address2: '31 號、37 號 7 樓及 31、33、35號 8 樓' },
    { name: '民安、泰安診所', address: '新竹中心', address1: '新竹市北區武陵路 189 號 3-5 樓', address2: '' },
    { name: '國泰功醫診所', address: '台南中心', address1: '台南市中西區永福路一段 185 號 2 樓', address2: '' },
  ];
  isZhTw = true;
  private langSub?: Subscription;
  // 取得當前應該顯示的三個圖標
  get visibleBuddies() {
    return this.buddyIcons.slice(
      this.displayStartIndex(),
      this.displayStartIndex() + 3
    );
  }
  // 只有在表單提交後才顯示錯誤
  get hasError(): boolean {
    return this.enterpriseCodeControl.invalid && this.isFormSubmitted;
  }
  // 手機版專用的計算屬性：只取出當前這組 3 個
  get mobileVisibleBuddies() {
    return this.buddyIcons.slice(this.mobileBuddyIndex(), this.mobileBuddyIndex() + 3);
  }
  private getCardsPerView(): number {
    return window.innerWidth < 768 ? 1 : 3;
  }
  private getMaxIndex(): number {
    return this.myths.length - this.getCardsPerView();
  }
  toggleFlip(index: number): void {
    const current = new Set(this.flippedCards());
    if (current.has(index)) {
      current.delete(index);
    } else {
      current.add(index);
    }
    this.flippedCards.set(current);
  }

  isFlipped(index: number): boolean {
    return this.flippedCards().has(index);
  }

  ngOnInit(): void {
    // 進入首頁時自動切換回中文
    this.isZhTw = this.translateService.currentLang === LANGS.ZH_TW;

    this.langSub = this.translateService.onLangChange.subscribe(event => {
      this.isZhTw = event.lang === LANGS.ZH_TW;
    });

    if (this.translateService.currentLang !== LANGS.ZH_TW) {
      setTimeout(() => {
        this.translateService.use(LANGS.ZH_TW);
      });
    }

    // 檢查是否有 landing_page 參數
    this.route.queryParams.subscribe(params => {
      console.log('Query params:', params);
      if (params['landing_page'] !== undefined) {
        // 彈窗邏輯
        if (this.showAnimation) {
          setTimeout(() => {
            const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
              disableClose: true,
              data: {
                showCloseButton: true,
                closeAction: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck']).then();
                },
                action: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck']).then();
                },
              },
            });
          }, 2400);
        } else {
          const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
            disableClose: true,
            data: {
              showCloseButton: true,
              closeAction: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck']).then();
              },
              action: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck']).then();
              },
            },
          });
        }
      }
    });
    if (this.showAnimation) {
      setTimeout(() => {
        // 展示過landing page一次後不再展示
        this.sharedStorageService.set('homeShowAnimation', false);
        this.showAnimation = false;
      }, 2400);
    }
    if (this.showTitleBlockAnimation) {
      setTimeout(() => {
        this.showTitleBlockAnimation = false;
      }, 2400);
    }
   this.buddyTimer = setInterval(() => {
  if (window.innerWidth <= 768) {
    return;
  }

  this.hoveredBuddy.set(
    (this.hoveredBuddy() + 1) % this.buddyCount
  );
}, this.buddyInterval);
    // this.startBuddyCarousel();
  }
  ngAfterViewInit() {
    const el = this.mythCards.nativeElement;
    // 這裡手動綁定，並設定 passive: false
    el.addEventListener('wheel', (e: WheelEvent) => this.onMythWheel(e), { passive: false });
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.isSectionInView.set(true);
          // 如果只需要觸發一次動畫，可以在這裡 disconnect
          // observer.disconnect(); 
        }
      },
      { threshold: 0.2 } // 當 Section 出現 20% 時觸發
    );

    observer.observe(this.sectionTeam.nativeElement);

    // 啟動手機版 buddy-grid 自動滑動
    if (window.innerWidth < 768) {
      this.startAutoScroll();
    }
    //tab可滑動
    setTimeout(() => {
      // 只在手機版啟用
      if (window.innerWidth > 768) {
        return;
      }

      const tabList = document.querySelector(
        '.habit-tabs .mat-mdc-tab-list'
      ) as HTMLElement | null;

      if (tabList) {
        tabList.style.overflowX = 'auto';
        tabList.style.overflowY = 'hidden';
        tabList.style.transform = 'none';

        tabList.style.setProperty(
          '-webkit-overflow-scrolling',
          'touch'
        );
      }
    });
  }
  ngOnDestroy(): void {
    clearInterval(this.buddyTimer);
    // 記得清除 Timer
    if (this.carouselTimer) clearInterval(this.carouselTimer);
    if (this.autoScrollTimer) clearInterval(this.autoScrollTimer);
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getIconPath(index: number, id: string): string {
    const isMobile = window.innerWidth <= 768;
    const suffix = this.hoveredBuddy() === index ? '' : '-default';
    return `assets/img/${id}${suffix}.svg`;
  }

  nextMyth(): void {
    if (!this.mythCards) return;
    const maxIndex = this.getMaxIndex();

    if (this.currentMythIndex >= maxIndex) {
      this.currentMythIndex = 0;
    } else {
      this.currentMythIndex++;
    }
    this.scrollMythToCurrent();
  }


  prevMyth(): void {
    if (!this.mythCards) return;
    const maxIndex = this.getMaxIndex();

    if (this.currentMythIndex <= 0) {
      this.currentMythIndex = maxIndex;
    } else {
      this.currentMythIndex--;
    }
    this.scrollMythToCurrent();
  }

  private scrollMythToCurrent(): void {
    const card = this.mythCards.nativeElement.querySelector('.myth-card') as HTMLElement;
    if (!card) return;

    const isMobile = window.innerWidth < 768;
    const gap = isMobile ? 16 : 530;
    const cardWidth = card.offsetWidth + gap;

    this.mythCards.nativeElement.scrollTo({
      left: this.currentMythIndex * cardWidth,
      behavior: 'smooth',
    });
  }
  onMythWheel(event: WheelEvent): void {
    const el = this.mythCards?.nativeElement;
    if (!el) return;

    // 1. 阻止頁面上下捲動
    event.preventDefault();

    // 2. 累加捲動數值 (deltaY 是垂直滾輪，轉換為水平位移)
    // 乘數 1.5 ~ 2 調整靈敏度
    el.scrollLeft += event.deltaY * 1.5;
  }
  onMouseDown(e: MouseEvent): void {
    const el = this.mythCards?.nativeElement;
    if (!el) return;

    this.isDragging = true;
    el.classList.add('grabbing'); // 增加抓取中的視覺效果

    // 記錄點擊時的初始位置
    this.startX = e.pageX - el.offsetLeft;
    this.scrollLeftStart = el.scrollLeft;
  }

  onMouseMove(e: MouseEvent): void {
    if (!this.isDragging) return;

    const el = this.mythCards?.nativeElement;
    if (!el) return;

    e.preventDefault(); // 防止選取文字或觸發拖曳圖片

    // 計算移動距離
    const x = e.pageX - el.offsetLeft;
    const walk = (x - this.startX) * 1.5; // 1.5 是靈敏度係數

    el.scrollLeft = this.scrollLeftStart - walk;
  }

  onMouseUpOrLeave(): void {
    this.isDragging = false;
    const el = this.mythCards?.nativeElement;
    if (el) {
      el.classList.remove('grabbing');
    }
  }
  startBuddyCarousel(): void {
    this.carouselTimer = setInterval(() => {
      // 每次跳 3 個，如果到底了就回到 0
      this.displayStartIndex.update(val =>
        (val + 3) >= this.buddyIcons.length ? 0 : val + 3
      );
    }, 2000); // 每 2 秒切換一次
  }

  startAutoScroll(): void {
    this.autoScrollTimer = setInterval(() => {
      if (!this.buddyGrid) return;

      const grid = this.buddyGrid.nativeElement;

      this.buddyIndex = (this.buddyIndex + 1) % this.buddyIcons.length;
      this.hoveredBuddy.set(this.buddyIndex);

      const item = grid.children[this.buddyIndex] as HTMLElement | undefined;
      if (!item) return;

      const targetLeft =
        item.offsetLeft -
        grid.clientWidth / 2 +
        item.clientWidth / 2;

      grid.scrollTo({
        left: targetLeft,
        behavior: 'smooth',
      });
    }, this.buddyInterval);
  }
  handleEnterpriseClick() {
    // 預防多次點擊
    if (this.isButtonDisabled || this.enterpriseCodeControl.invalid) {
      return;
    }

    const inputCode = this.enterpriseCodeControl.value?.trim() ?? '';

    // 將輸入的網路預約代碼轉換為公司代碼
    // const companyCode = this.companyCodeMappingService.convertWebCodeToCompanyCode(inputCode);

    console.log('輸入代碼：', inputCode);
    // console.log('轉換後的公司代碼：', companyCode);

    this.isFormSubmitted = true;

    if (this.enterpriseCodeControl.valid) {
      // 檢查企業代碼格式
      if (this.enterpriseCodeControl.invalid) {
        this.enterpriseCodeControl.markAsTouched();
        return;
      }

      this.isButtonDisabled = true;
      // 設定預約類型為企業
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
        if (this.flowCode === '4') {
          this.isButtonDisabled = false;
          const completeExamDialog = this.dialog.open(
            SingleActionDialogComponent,
            {
              data: {
                title: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.title'
                ),
                message: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.message'
                ),
                buttonText: this.translateService.instant(
                  'id-login.go-to-member-center'
                ),
                showCloseButton: true,
                closeAction: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/']).then();
                },
                action: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                },
              },
            }
          );
        } else {
          // 驗證企業資訊(CB-040) - 已登入
          this.verifyMemberEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
        }
      } else {
        // 驗證企業資訊(CB-040) - 未登入
        this.verifyMemberEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
      }
    }
  }
  // 驗證企業資訊 (CB-040) - 已登入
  verifyMemberEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(已登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  closeAction: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                  action: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {

              this.router.navigate(['/healthcheck/companylogin']).then();
            } else {
              this.router.navigate(['/healthcheck/idlogin']).then();
            }
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
          // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
              action: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 驗證企業資訊 (CB-040) - 未登入
  verifyNewEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(未登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  action: () => {
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/idlogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            console.log('查無企業資料');
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
          // // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
              action: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }
  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^A-Za-z0-9-]/g, '').slice(0, 10); // 改成允許英文、數字和連字號

    // 同步更新 FormControl 的值
    if (this.enterpriseCodeControl.value !== sanitizedValue) {
      this.enterpriseCodeControl.setValue(sanitizedValue, { emitEvent: false });
    }

    // 清除錯誤狀態
    if (this.hasError) {
      this.isFormSubmitted = false;
    }

    // 重新驗證
    this.enterpriseCodeControl.updateValueAndValidity();
  }

  // 查無企業資料
  openNoEnterpriseDialog() {
    const noEnterpriseDialog = this.dialog.open(
      SingleActionDialogComponent,
      {
        disableClose: true,
        data: {
          title: this.translateService.instant(
            'error.company-code-error.error-title'
          ),
          message: this.translateService.instant(
            'error.company-code-error.message'
          ),
          buttonText: this.translateService.instant(
            'common.button.i-understood'
          ),
          showCloseButton: false,
          action: () => {
            this.sharedStorageService.clear();
            this.isButtonDisabled = false;
            noEnterpriseDialog.close();
            return;
          },
        },
      }
    );
  }

  handlePersonalClick() {

    // 標記即將進行個人健檢流程
    this.sharedStorageService.set('fromIdLogin', true);
    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    // 設定預約類型為個人
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);

    // 驗證 token 有效性
    this.authService.refreshSessions().subscribe(res => {
      console.log('refreshSessions success:', res);
      // EC6009 代表 token 過期
      if (res.statusCode === 'EC6009' || res.statusCode === 'E9028') {
        // token 過期，清除資料並重新登入
        console.log('token 過期，清除資料並重新登入');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      }
      else if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
        this.reservedBlocking('/healthcheck/reserve/location');
      } else {
        console.log('EC6007 未登入，導向idLogin');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      }
    },
      (error) => {
        console.error('refreshSessions error:', error);
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => { });
      });

  }

  reservedBlocking(router: string) {
    if (this.flowCode === '4') {
      const completeExamDialog = this.dialog.open(
        SingleActionDialogComponent,
        {
          data: {
            title: this.translateService.instant(
              'id-login.login-already-reserved-dialog.title'
            ),
            message: this.translateService.instant(
              'id-login.login-already-reserved-dialog.message'
            ),
            buttonText: this.translateService.instant(
              'id-login.go-to-member-center'
            ),
            showCloseButton: true,
            closeAction: () => {
              completeExamDialog.close();
              this.router.navigate(['/']).then();
            },
            action: () => {
              completeExamDialog.close();
              this.router.navigate(['/healthcheck/member/mybooking']).then();
            },
          },
        }
      );
    } else {
      this.router.navigate([router]).then();
    }
  }

  handleQuickReserveClick() {
    // 設定預約類型為個人
    // 檢查環境配置，如果是 prod 環境則導向 not-available 頁面
    // 2026/2/2 打開prod
    this.sharedStorageService.set('reserveStep', 1); // 重置為步驟 1
    // const env = (window as any)?.env;
    // if (env?.environment === 'prod') {
    //   this.router.navigate(['/not-available']).then();
    //   return;
    // }
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    if (
      this.sharedStorageService.get(STORAGE_KEY.LOGIN_STATUS) !== 'memberLogin' &&
      !createMemberRequest?.idNo &&
      !this.authService.isLogin()
    ) {
      this.sharedStorageService.set(STORAGE_KEY.LOGIN_STATUS, 'newFriend');
    }
    this.reservedBlocking('/healthcheck/reserve/location');

  }
  openCalculationDialog() {
    const dialogRef = this.dialog.open(CtaDialogComponent, {
      width: '100%',
      maxWidth: '520px', // 配合你圖片中的設計寬度
      panelClass: 'cta-modal-pane', // 使用自定義類名
      autoFocus: false,   // 防止自動聚焦到輸入框導致手機版鍵盤彈出遮擋
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('使用者點擊了確定，開始執行試算邏輯...');
        // 這裡可以寫路由跳轉，例如：this.router.navigate(['/questionnaire']);
      }
    });
  }
}
